export type dentaCptDetailsType = {
    cptStatus: string | null; // Assuming it can be null or a string
    cptDes: string;
    cptName: string;
    insCoverage: number;
    cptGroupId: number;
    cptId: number;
    cptCode: string;
    cptRate: number;
    isFavorite?: number;
  };


 export type DentalCptPayload = {
    clinicId: number;
    encounterId: number; // Replace `number` with `string` if `encounterId` is a string
    searchText: string;
    groupId: number;
    userGroup: number;
    userId?: number | null;
  };


  export interface Tooth {
    id: number|null;
    toothNo: number;
    section: {
      l1: boolean;
      l2: boolean;
      r1: boolean;
      r2: boolean;
      c: boolean;
    };
    image1: string;
    image2:string
  }
  
  interface CPTDetails {
    cptDescription: string;
    cptGroupName: string;
    cptId: number;
    cptRate: number;
    cptGroupId: number;
    cptName: string;
    cptCode: string;
  }
  
  export interface Procedure {
    procedureId: number;
    patientId: number | null;
    visitId: number | null;
    cptId: number | null;
    encounterId: number | null;
    remarks: string | null;
    doctorsRemarks: string | null;
    toothNo: number | null;
    quantity: number;
    amount: number;
    priorAuthorizationCode: string | null;
    status: string | null;
    ip: string | null;
    companyId: number | null;
    reason:string|null;
    outHouse:boolean|null;
    isApprovalRequired: boolean | null;
    isDenialCode: boolean | null;
    isPerformed: boolean | null;
    isDentalExam: boolean | null;
    isService: boolean | null;
    isExclude: boolean | null;
    createdId: number | null;
    clinicId: number | null;
    isBilled: boolean | null;
    insDiscount: number;
    insAmount: number | null;
    unitRate: number;
    createdDate: string; // ISO date string
    isModified: number;
    userType: string | null;
    nursingProcedure: string | null;
    nursingRemarks: string | null;
    revertFlag: string | null;
    actionCode: string | null;
    insCoverage: string | null;
    hl7MsgStatus: string | null;
    cptDetails: CPTDetails;
    pShare: number;
    paymentMode: number | null; // Assuming paymentMode can be null
    discountPercentage: number | string | null;
    discountAmount: number | string | null;
    actualPatshare?: number | null;
  }
  
  export interface DentalRecord {
    tooth: Tooth[];
    procedure: Procedure;
  }

  export const defaultValue = {
    IsPerfomed: false, 
    Patientshare: "", 
    Quantity: 0, 
    Reason: "", 
    Remark: "", 
    amount: 0, 
    Rate:0,
    approvalRequired: false, // Default to false
    cpt:null,
    nursingProcedure: false, 
    toothNo: [], 
    discount: "",
    discountType: "Percentage",
  };
  
  
  // Example of an array of records
 export  type DentalRecords = DentalRecord[];
  
  